<template>
  <div>
    <div class="credit ws-textbox">
      <h2 class="title-choose-photo" style="margin-bottom: 0px">
        <u>{{ lang['meal_plan_photo_claim_new'].SFS_LANG_ROW_2 }}</u>
      </h2>
      <h2 class="title-choose-photo" style="margin-bottom: 0px">
        <u>{{ currency }} {{ formatPrice(totalAmount) }}</u>
      </h2>
    </div>
    <div
        class="photo2claim-help ws-textbox"
        :style="{ 'float': this.direction == 'rtl' ? 'right' : 'left' }"
    >
      <h2 class="title-choose-photo">
        <u>{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_3'] }}</u>
      </h2>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(1, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_8'] }}</span>
        </p>
      </div>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(2, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_9'] }}</span>
        </p>
      </div>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(3, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_10'] }}</span>
        </p>
      </div>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(4, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_11'] }}</span>
        </p>
      </div>
    </div>
    <div style="clear: both"></div>
    <!-- step 1 -->
    <div class="step-photo ws-textbox">
      <h2 class="title-choose-photo">
        <u>{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_12'] }}</u>
      </h2>
      <div v-if="listPaxReceipt.length > 0">
        <p class="mb-2">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_13'] }}</p>
        <div class="list-receipt">
          <div v-for="(item, k) in listPaxReceipt" :key="k" class="item-receipt mb-3">
            <div v-if="!item.remake">
              <div class="img-item-receipt">
                <div v-if="isPdf(item.image_url)" class="pdf-container">
                  <embed class="pdf-object" :src="item.image_url" type="application/pdf" />
                </div>
                <img v-else :src="item.image_url" alt="" />
              </div>
              <div class="pt-3 receipt-amount">
                <p>{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_14'] }}: {{ item.currency }} {{ item.amount }}</p>
              </div>
              <div class="btn-handle-receipt btn-handle">
                <p class="btn-handle-check" :class="listPaxReceipt.length > 0 ? 'mr-2' : ''" @click="removePicture(k)">
                  {{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_16'] }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="!listPaxReceipt">
            <div class="mb-2">
              <div class="btn-take-photo">
                <button class="" @click="handleClickFileUpload('receipt')">
                  <i class="fas fa-camera"></i> {{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_17'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="mb-2">
          <div class="btn-take-photo">
            <button v-if="uploadReceipt || listPaxReceipt.length == 0" @click="handleClickFileUpload('receipt')">
              <i class="fas fa-camera"></i>
            </button>
            <button v-else class="ws-btn add-receipt2" @click="handleClickFileUpload('receipt')">
              <i class="fas fa-plus"></i> {{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_17'] }}
            </button>
          </div>
        </div>
      </div>
      <input
        id="file-receipt"
        ref="receipt"
        type="file"
        accept="image/*;capture=camera"
        style="display: none"
        @change="handleFileUpload($event, 'receipt')"
      />
    </div>
    <!-- step 2 -->
    <div v-if="showBankDetail" style="margin-bottom: 10px">
      <NewTransferWiseForm
        :wise-bank-detail="MealPlanInfo.bank_info"
        :lang-transfer-wise="lang.meal_plan_photo_claim_new"
        :is-name-null="isNameNull"
        @updateInfoPaxBank="updateInfoPaxBank"
        @updateIsNameNull="updateIsNameNull"
      />
    </div>
    <div v-if="pax.enable_ref_print_a4 == 1" class="step-photo">
      <p
        style="padding: 0.5rem 0"
        v-html="replaceStr(lang.meal_plan_photo_claim_new['SFS_LANG_ROW_18'], ['<airline>'], [airline.name])"
      ></p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import vueCountryRegionSelect from 'vue-country-region-select'
import { replaceStr, isPdf } from '@/utils/helper'
import { mapGetters } from 'vuex'
import NewTransferWiseForm from '@/components/NewTransferWiseForm/Index'
Vue.use(vueCountryRegionSelect)
export default {
  components: {
    NewTransferWiseForm
  },
  props: {
    secret: {
      type: String,
      default: ''
    },
    MealPlanInfo: {
      type: Object,
      default: () => {}
    },
    MealPlanPriceTotalPax: {
      type: Array,
      default: () => []
    },
    isNameNull: Boolean
  },
  data() {
    return {
      file: '',
      idx: 0,
      enableSingleUse: 0,
      uploadReceipt: true,
      listPaxReceipt: [],
      listRemake: [],
      infoPaxBank: {},
      keyReceipt: null,
      mealPlanService: {},
      mealPlanDetail: {},
      notifyValidSwift: false,
      totalAmount: 0,
      validateInfoBank: {},
      showPopupPrinted: false,
      currencyReceipt: '',
      showBankDetail: false,
      currency: 'EUR'
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services'
    })
  },
  watch: {
    Services: {
      handler() {
        this.initData()
      },
      deep: true
    },
    MealPlanInfo(val) {
      this.initData()
    },
    MealPlanPriceTotalPax: {
      handler() {
        this.totalAmount = _.sumBy(this.MealPlanPriceTotalPax, function (o) {
          return parseFloat(o.valamount)
        })
      },
      deep: true
    }
  },
  mounted() {
    if (_.find(this.Services, { service_id: 1 })) {
      this.initData()
    } else {
      this.$store.dispatch('Home/getServices')
      this.initData()
    }
  },
  methods: {
    replaceStr,
    isPdf,
    initData() {
      let self = this
      if (self.showPopupPrinted) {
        return
      }
      self.mealPlanService = _.find(self.Services, { service_id: 23 })
      self.mealPlanDetail = _.find(self.mealPlanService.list_meal_plan, { voucher_code: this.$route.query.voucher_code })
      this.currency = self.mealPlanService.currency ? self.mealPlanService.currency : this.currency
      if (self.mealPlanDetail.currency) {
        this.currency = self.mealPlanDetail.currency
      }
      if (self.mealPlanDetail && self.mealPlanDetail.is_printed && !self.showPopupPrinted) {
        self
          .$swal({
            title: self.lang.meal_plan_photo_claim_new['SFS_LANG_ROW_19']
          })
          .then(() => {
            self.$router.push({ path: '/home', query: { secret: self.secret } })
          })
        self.showPopupPrinted = true
        return
      }
      if (self.MealPlanInfo && self.MealPlanInfo.bank_info) {
        if (self.MealPlanInfo.list_receipt && self.MealPlanInfo.list_receipt.length > 0) {
          self.listPaxReceipt = self.MealPlanInfo.list_receipt
          self.currencyReceipt = self.listPaxReceipt[0]['currency']
          self.showBankDetail = self.listPaxReceipt.length > 0 ? true : false
          self.uploadReceipt = false
        }
      }
      if (!_.isEmpty(self.airline.params)) {
        self.enableSingleUse = self.airline.params.photo2claim.enable_single_use
      }
      if (self.MealPlanPriceTotalPax) {
        self.totalAmount = _.sumBy(self.MealPlanPriceTotalPax, function (o) {
          return parseFloat(o.valamount)
        })
      }
    },
    checkSwift(e) {
      let value = e.target.value
      if (value) {
        this.notifyValidSwift = false
      }
    },
    removePicture(key) {
      this.listRemake.push(this.listPaxReceipt[key].image_path)
      _.remove(this.listPaxReceipt, function (n, k) {
        return k == key
      })
      this.currencyReceipt =
        this.listPaxReceipt.length == 0 || this.listPaxReceipt.length == this.listRemake.length ? '' : this.currencyReceipt
      this.showBankDetail = this.listPaxReceipt.length > 0 ? true : false
      this.$forceUpdate()
    },
    handleClickFileUpload(refName) {
      this.$refs[refName].click()
    },
    handleFileUpload: function (event, type) {
      if (event) {
        event.stopPropagation()
      }
      this.file = this.$refs[type].files[0]
      this.submitFile(event, type)
    },

    updateInfoPaxBank(infoPaxBank) {
      this.infoPaxBank = infoPaxBank
      this.saveInfoPax()
    },

    saveInfoPax() {
      let self = this
      let listPaxReceiptRemake = _.cloneDeep(self.listPaxReceipt)
      _.remove(listPaxReceiptRemake, { remake: true })
      if (listPaxReceiptRemake.length == 0) {
        self.$swal(this.lang.meal_plan_photo_claim_new['SFS_LANG_ROW_20'])
        return false
      }
      let totalAmount = 0
      _.forEach(self.listPaxReceipt, function (item) {
        item.service_id = 23
        totalAmount += parseFloat(item.amount)
      })
      if (totalAmount == 0) {
        self.$swal(
          this.lang.meal_plan_photo_claim_new['SFS_LANG_ROW_36'] || 'Unable to upload receipt with value 0, please upload other!'
        )
        return false
      }
      self.infoPaxBank.service_id = 23 // service meal plan
      self.infoPaxBank.amount = totalAmount
      let dataSend = {
        data: {
          list_receipt: self.listPaxReceipt,
          list_remake: self.listRemake,
          info_bank: self.infoPaxBank
        },
        secret: self.secret,
        voucher_code: this.$route.query.voucher_code
      }

      this.$store.dispatch('MealPlan/saveInfoPax', dataSend).then((response) => {
        if (response) {
          if (response.success == false) {
            if (response.message) {
              if ((response.message.wsData && response.message.wsData.errors) || response.revolut_message) {
                self.$swal(
                  self.lang?.meal_plan_photo_claim_new['SFS_LANG_TRANSFER_WISE_16'] ||
                    'This account is not validated. Please retype your account details'
                )
              } else if (typeof response.message === 'string' || response.message instanceof String) {
                self.$swal(response.message)
              } else {
                self.$swal('Action failed')
              }
            } else {
              self.$swal('Action failed')
            }
          }
          this.$store.dispatch('MealPlan/getInfoMealPlan', this.$route.query.voucher_code)
        }
      })
    },
    addReceipt() {
      this.uploadReceipt = true
    },
    submitFile(event, type) {
      if (!this.file) {
        return false
      }

      let max_size = 20
      if (this.airline.params && this.airline.params.klippa && this.airline.params.klippa.maximum_file_size) {
        max_size = this.airline.params.klippa.maximum_file_size
      }
      let self = this
      let fileSize = parseFloat((this.file.size / 1024 / 1024).toFixed(4))
      if (fileSize > max_size) {
        self.$swal(self.replaceStr(self.lang.meal_plan_photo_claim_new['SFS_LANG_ROW_21'], '<maximum_file_size>', max_size))
        this.$refs[type].value = null
        return false
      }
      let formData = new FormData()
      formData.set('secret', this.secret)
      formData.append('image', this.file)
      this.uploadReceipt = false
      // Upload file
      self.$store.dispatch('Refreshment/uploadImg', { formData }).then((response) => {
        this.$refs[type].value = null
        if (response.success) {
          let resData = response.data
          if (type == 'receipt') {
            if (!self.checkTImePurchase(resData.purchasedate, resData.purchasetime)) {
              self.$swal(self.lang.meal_plan_photo_claim_new['SFS_LANG_ROW_22'])
              this.listRemake.push(resData.image_path)
              return false
            }
            let receiptAdd = {
              image_url: resData.image_url,
              image_path: resData.image_path,
              merchant_name: resData.merchant_name,
              purchase_date: resData.purchasedate,
              purchase_time: resData.purchasetime,
              currency: resData.currency,
              amount: (parseFloat(resData.amount) / 100).toFixed(2),
              amount_include: (parseFloat(resData.vatamount) / 100).toFixed(2),
              params: JSON.stringify(resData)
            }
            if (!_.isEmpty(self.currencyReceipt) && resData.currency != self.currencyReceipt) {
              self.$swal(self.lang.meal_plan_photo_claim_new['SFS_LANG_ROW_23'])
              this.listRemake.push(resData.image_path)
              return false
            } else {
              self.currencyReceipt = resData.currency
            }
            let totalAmount = 0
            if (!_.isNull(self.keyReceipt)) {
              let idReceipt = _.cloneDeep(self.listPaxReceipt[self.keyReceipt].id)
              self.listPaxReceipt[self.keyReceipt] = receiptAdd
              _.forEach(self.listPaxReceipt, function (item) {
                totalAmount += parseFloat(item.amount)
              })
              self.listPaxReceipt[self.keyReceipt].id = idReceipt
              self.listPaxReceipt[self.keyReceipt].remake = false
              self.keyReceipt = null
            } else {
              _.forEach(self.listPaxReceipt, function (item) {
                totalAmount += parseFloat(item.amount)
              })
              totalAmount += parseFloat(receiptAdd.amount)
              self.listPaxReceipt.push(receiptAdd)
            }
            self.uploadReceipt = false
          }
          self.showBankDetail = self.listPaxReceipt.length > 0 ? true : false
          self.$forceUpdate()
        } else {
          self.$swal(self.lang.meal_plan_photo_claim_new['SFS_LANG_ROW_24'])
        }
      })
    },
    checkTImePurchase(date, time) {
      // Config to skip check validate expiry time
      if (!this.airline.params.photo2claim.validation_check_expiry_time) {
        return true
      }

      let expire_hour = parseInt(this.airline.params.photo2claim.expire_hour || 12)
      let flightTime = this.pax.etd ? this.pax.etd : this.pax.std
      let datePurchase = this.moment(date + 'T' + time)
      let timeEnd = this.moment(flightTime).add(expire_hour, 'hours')

      return datePurchase <= timeEnd
    },
    checkReceipt() {
      let self = this
      let listPaxReceiptRemake = _.cloneDeep(self.listPaxReceipt)
      _.remove(listPaxReceiptRemake, { remake: true })
      if (listPaxReceiptRemake.length == 0 || listPaxReceiptRemake.length !== self.listPaxReceipt.length) {
        self.$swal(this.lang.meal_plan_photo_claim_new['SFS_LANG_ROW_20'])
        return false
      }
      return true
    },
    iConClass: function (type, lang) {
      let className = ''
      switch (type) {
        case 1:
          className = lang.meal_plan_photo_claim_new['SFS_LANG_ROW_4']
            ? lang.meal_plan_photo_claim_new['SFS_LANG_ROW_4']
            : 'fas fa-shopping-basket'
          break
        case 2:
          className = lang.meal_plan_photo_claim_new['SFS_LANG_ROW_5']
            ? lang.meal_plan_photo_claim_new['SFS_LANG_ROW_5']
            : 'fas fa-camera'
          break
        case 3:
          className = lang.meal_plan_photo_claim_new['SFS_LANG_ROW_6']
            ? lang.meal_plan_photo_claim_new['SFS_LANG_ROW_6']
            : 'far fa-credit-card'
          break
        case 4:
          className = lang.meal_plan_photo_claim_new['SFS_LANG_ROW_7']
            ? lang.meal_plan_photo_claim_new['SFS_LANG_ROW_7']
            : 'fas fa-gift'
          break
        default:
      }

      return className + ' fa-2x'
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2)
      return val.toString()
    },
    strReplace(str) {
      let self = this
      let search = ['<currency>', '<amount_total>']
      let rep = [self.mealPlanService.currency, self.formatPrice(self.totalAmount)]
      return self.replaceStr(str, search, rep)
    },
    updateIsNameNull(value) {
      this.$emit('updateIsNameNull', value)
    }
  }
}
</script>
<style scoped>
.pdf-container {
  width: 100%;
  height: 0;
  padding-bottom: 100%; /* Set the aspect ratio to match the page size */
  position: relative;
  overflow: hidden;
}

.pdf-object {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
